// Lightweight OG / Twitter meta tag manager for SPA pages.
// Updates the existing tags from index.html in place (instead of creating duplicates).

// Absolute URL is required — social scrapers (iMessage, Facebook, WhatsApp,
// Twitter) cannot resolve relative paths. We use the public site origin.
const SITE_ORIGIN =
  (typeof window !== "undefined" && window.location && window.location.origin) ||
  "https://www.poolgurutc.com";
const FALLBACK_IMAGE = `${SITE_ORIGIN}/og-image.jpg?v=4`;

function upsertMeta(selector, attr, attrValue, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function applyOGTags({ title, description, image, url, type = "website" }) {
  const finalImage = image || FALLBACK_IMAGE;
  upsertMeta('meta[property="og:title"]', "property", "og:title", title);
  upsertMeta('meta[property="og:description"]', "property", "og:description", description);
  upsertMeta('meta[property="og:image"]', "property", "og:image", finalImage);
  upsertMeta('meta[property="og:url"]', "property", "og:url", url || window.location.href);
  upsertMeta('meta[property="og:type"]', "property", "og:type", type);
  upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
  upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
  upsertMeta('meta[name="twitter:image"]', "name", "twitter:image", finalImage);
}

// No-op cleanup retained for backwards compatibility with existing callers.
export function clearOGTags() {}
